export default "__VITE_ASSET__BumwuYcm__"